import compact from 'lodash/compact';

export function cartJsonData(resCartApiData) {
  // console.log(resCartApiData);
  const {
    rtnCode,
    rtnMsg,
    nowCartType,
    CartType,
    accountInfo,
    // 加盟商相關欄位
    appliedFranchiseeTotal,
    isFranchisee,
    isAppliedFranchisee,
    discountDisable,
    // isACMOrder 前端不使用
    isAppliedBonus,           // true 顯示已使用，要連動紅利金數字, false 顯示可以使用
    totalitem_bonus_prize,
    userCanUseBonus,
    estimateBonusTotal,
    isDisablePromotion,
    isPickupEnabled,
    // is_all_pickup 前端不使用 
    totalitem_market_actions,
    totalitem_ori_prize,                  // 原價
    totalitem_rec_prize,                  // 登高總計使用
    totalitem_rec_prize_no_ExtraFee,      // 購買總計
    totalitem_rec_prize_no_deliverycost,  // 2/10 後端: 物流費
    totalitemnum,
    totalitem_saf_prize,
    deliverycost,
    carts,
    coupon,                                // 整台車的折價券
    stocksErrorMsg,                         //庫存不足訊息
    logisticsCostsInfo,
    ipsInfo                                 // IPS 基本出工資及跨區費顯示資訊
  } = resCartApiData;

  let tempCartTypePriority = [];

  // 陣列排序
  CartType.forEach((cart) => {
    // 照順序排
    if (cart === "instock") {
      tempCartTypePriority[0] = cart;
    }
    if (cart === "preorder") {
      tempCartTypePriority[1] = cart;
    }
    if (cart === "vendor") {
      tempCartTypePriority[2] = cart;
    }
    if (cart === "groupbuy") {
      tempCartTypePriority[3] = cart;
    }
  })

  // 移除為空的值
  const setCartTypePriority = compact(tempCartTypePriority);

  // 因為這邊的 key 寫得滿糟的常常會有反邏輯，所以在這邊整理一下
  // 但是資料有可能在 html 裏面要轉到 api res 的問題
  // 這裡會針對可能 資料分組、反邏輯整理成正邏輯、然後變數命名一致化 而去做 controller 一致化
  // 基本上做這件事情就是想辦法把可能沒有用到的 key 給 hight-light 出來
  if (typeof resCartApiData === 'object') {
    if (rtnCode === 1) {
      // 整理後的 cart 資料第一層

      let isShowCartItem;

      const overviewData = {
        priceGroup: accountInfo.priceGroup,
        qty: accountInfo.prodNum,
        totalPrice: accountInfo.totalprice
      };

      const carrierFee = setCarrierFee(accountInfo.priceGroup);

      const data = {
        // 回傳主要資料
        status: rtnCode,
        message: rtnMsg,
        data: {
          // 購物車類別
          nowType: nowCartType.toLowerCase(),
          allTypes: setCartTypePriority,

          // 加盟商 參數
          franchiseData: {
            totalDiscount: appliedFranchiseeTotal,                                                   // 加盟商折價價格
            isShowInput: (isFranchisee === "true" && isAppliedFranchisee === "false"),           // 顯示加盟商輸入框
            isShowSingleItemDiscount: (isFranchisee === "true" && isAppliedFranchisee === "true" && appliedFranchiseeTotal > 0),   // 顯示加盟商折價
          },

          // 這塊聽說目前棄用，萬一又要用的話就在打開再看要怎麼 mapping 就好
          // // 紅利金 參數
          // bonusGoldData: {
          //   isUseBonusGold:             (isAppliedBonus === "true"),
          //   // 已使用 使用點數
          //   usedBonusGold:              totalitem_bonus_prize,
          //   // 未使用 現有、折抵
          //   userCanUseBonusPoints:      userCanUseBonus,
          //   canDiscountPoints:          estimateBonusTotal,
          // },

          config: {
            isShowDiscountDiv: !discountDisable,
            isShowItemPromotion: !isDisablePromotion,
            isShowItemPickUpOption: isPickupEnabled,
            isShowCartItem: "",
            usedDiscountStatus: setDiscountStatus(coupon, pointToCoupon, cartPoint, discountDisable),
            isShow2ndStepFooterSavingsPrice: (totalitem_saf_prize && totalitem_saf_prize !== '$0'),
            isShow2ndStepFooterCarrierPrice: (carrierFee && carrierFee !== '$0'),
          },

          preBriefSection: {
            qty: totalitemnum,
            originPrice: totalitem_ori_prize,
            discountPrice: totalitem_rec_prize_no_deliverycost,
            savings: totalitem_saf_prize,
            carrierFee: carrierFee,
            totalPrice: accountInfo.totalprice,
            deliveryFee: accountInfo.feeprice,
          },

          order: {
            qty: totalitemnum,
            allItemsPromotion: totalitem_market_actions,
            originPrice: totalitem_ori_prize,
            amount: totalitem_rec_prize_no_ExtraFee,
            amountWithFreightCharge: totalitem_rec_prize,  // 登高總計使用
            deliveryCost: deliverycost,
            coupon: couponFormatter(coupon),
          },

          // jsp來的變數cartPoint(會員已使用點數)、pointToCoupon
          usedPoint: cartPoint,
          pointToCoupon: pointToCoupon,

          // 手機 modal / 桌機固定選單資料
          overview: overviewData,
          carts: [],
          zoneCarts: [],
          ipsInfo: ipsInfo,

          cartFooterWording: logisticsCostsInfo,
          stocksErrorMsg:stocksErrorMsg
        }
      }

      carts.forEach((cart, index) => {
        // console.log(cart);
        // 因為以前的購物車是一台車然後宅配跟店取分開欄位，後來歸類都歸在現貨訂購裏面了
        // 所以看起來才會變成好像用得到的資料變得很少
        // 理論上現在真的用得到的應該會只剩下 orderitem 裏面的東西

        let cartsArrayItem = {
          type: "",
          orders: [],
          groupName: '' 
        };

        const {
          // ascendingTotal,        // 前端沒使用
          // carttime,              // 前端沒使用，掃 code 沒看到
          channel_name,
          // deliverOriginTotal,    // 前端沒使用
          // deliverTotal,          // 前端沒使用，配送/店取狀態的優惠價
          // deliveryMode,          // 前端沒使用
          // freightChargeFlag,     // 前端沒使用
          // installationFeeTotal,  // 前端沒使用
          orderitem,
          // pickupOriginTotal,     // 前端沒使用，店取原價
          // pickupTotal,           // 前端沒使用
          remoteLocationFee,        // 偏遠地區加成費用
          // totalitem_saf_prize,   // 前端沒使用，宅配/店取 節省金額
          // volumeExceedTotal,     // 前端沒使用
          // weightExceedTotal      // 前端沒使用，理論上是超重資訊
          group_name,               // 任選分類才有的活動名稱
        } = cart;

        // console.log(orderitem);
        orderitem.forEach((item) => {
          const {
            addBuy,
            bundleProduct, //組合商品
            addMessage,      // 前端沒使用, wording 目前有看到的是 "商品免運，故不列入運費門檻計算"(待釐清)
            ascendingFeeAmount,
            // bonusMDCateGiveRate, // 前端沒使用
            canInstallationFlag,
            couponFlag,
            deliveryAppointmentFlag,
            remark,     // 商品備註
            entry_qty,
            has_pickup,
            homepick,
            installationFeeAmount, 
            isDisablePromotion,
            isRemove,
            isTracking,
            // market, // 前端沒使用
            // market_action, // 疑似沒用因為後面全部轉成用 array
            market_actions,
            max_quantity,
            needInstallationFlag,
            order_number,
            original_price,
            // prodInstallationFeeAmount, // 前端沒使用
            productCanUseBonus,
            productCanUseBonusRate,
            product_name,
            product_pic,
            product_sku,
            // product_style_color, // 前端沒使用
            // product_style_size, // 前端沒使用
            // promoFlag, // 前端沒使用
            promotionLabel,
            sale_price,
            // salesChannel, // 前端沒使用 後面要用這個欄位去判斷到底是哪個通路
            sharedBonusDiscount,
            sharedFranchiseeDiscount,
            specialFlag, // 前端沒使用 後面會使用這個欄位去判斷 客訂商品
            storepick,
            total_price,
            userCoupon,
            // vendor_id, // 前端沒使用
            volumeExceedFeeAmount,
            weightExceedFeeAmount,

            productTypeTags,  // 商品類型圖標
            channelImg,       // 商品通路圖標
            deliveryTypeTags, // 訂製、預購...商品狀態圖標
            storeaddress,
            shareVendor, //LINE回饋%數
            entryExtraFees,   // 額外費用 [{dsr: '宅配', price: '$299'},{dsr: '安運費', price: '$150'}]
          } = item;

          let cartItemListItem = {
            // optionBuyingItems 裏面的資料可能要再整理
            optionBuyingItems: addBuy,
            bundleProductItems: bundleProduct, //存放組合商品

            salePrice: sale_price,
            originalPrice: original_price,
            // 商品小計
            totalPrice: total_price,

            orderNumber: order_number,

            // 超過費用
            exceedFeeAmount: {
              // 體積
              volume: volumeExceedFeeAmount,
              // 重量
              weight: weightExceedFeeAmount,
            },

            // coupons 裏面的資料可能還要再整理，邏輯很怪
            coupons: userCoupon,

            bonus: {
              bonusRate: productCanUseBonusRate,
              maxAmount: productCanUseBonus,
              // 單一商品紅利金折抵金額
              discount: sharedBonusDiscount,
            },

            // 加盟商優惠金額
            franchiseeDiscount: sharedFranchiseeDiscount,
            // 店取店名
            pickStoreName: storepick,

            pickStoreAddress: storeaddress,

            // 單一商品促銷，可能還要在改一下 key
            promotions: market_actions,
            // 促銷小標、通常是贈品標、會在品名下方
            bonusProductionLabel: promotionLabel,

            installation: {
              // 付費安運開關
              isShow: canInstallationFlag,
              // 付費安運開關 - 意義上比較像是定義是否為需要被安運的商品
              isNeed: needInstallationFlag,
              // 付費安運價格
              amounts: installationFeeAmount,
            },

            // 登高費
            ascendingFeeAmount: ascendingFeeAmount,

            product: {
              name: product_name,
              image: product_pic,
              sku: product_sku,
            },

            config: {
              // "不適用折價券"字樣顯示開關
              isShowCanUseCouponWording: !couponFlag,
              // 是否為約配商品
              isShowDeliveryAppointmentWording: deliveryAppointmentFlag,
              // 促銷文案（可能多筆）顯示開關 ，實際上應該是是否為約配商品
              isShowPromotionWording: deliveryAppointmentFlag,
              // 是否為店取 - true: 店取 / false: 宅配
              isPickUp: has_pickup,
              // 是否顯示商品可購買 selector
              isShowQtySelector: homepick,
              // 是否顯示商品可購買 selector
              homePick: homepick,
              // 是否顯示折價券折抵按鈕
              isShowPromotionButton: !isDisablePromotion,
              // 是否顯示移除按鈕
              isShowRemoveButton: isRemove,
              // 是否為已收藏
              isAddedToTrackStatus: (isTracking === "Y" ? true : false),
              // 是否為訂製商品
              isCustomized: specialFlag,
              // 登高結帳頁是否顯示「超材/重計費」wording
              isShowExceedFeeAmountWording: dealToIsShowExceedFeeAmountWording(volumeExceedFeeAmount, weightExceedFeeAmount),
              // 登高結帳頁是否顯示「安運費」wording
              isShowInstallationWording: dealToIsShowInstallationWording(installationFeeAmount),
              // 登高結帳頁是否顯示「登高費」wording
              isShowAscendingFeeAmountWording: dealToIsShowAscendingFeeAmountWording(ascendingFeeAmount),
              isShowPickupOrDeliverChoice: (nowCartType.toLowerCase() !== 'preorder' && nowCartType.toLowerCase() !== 'vendor'),
              isShowNoDeliverFeeInfo: addMessage && deliveryAppointmentFlag === false,
            },

            qty: {
              // 購買數量
              userBuying: entry_qty,
              // 最大數量
              max: max_quantity,
            },

            productTypeTags: productTypeTags,

            channelImg: channelImg,

            deliveryTypeTags: deliveryTypeTags,
            // line 回饋％數
            shareVendor : shareVendor,

            entryExtraFees: entryExtraFees,
            remark: remark,
          };

          cartsArrayItem.orders.push(cartItemListItem);

          // 這個應該可以變成是改預設值就好，除非後端診的有講哪個 key 是要隱藏的我們在接上去
          isShowCartItem = true;
        });

        // 這裡的 coding style 跟前面不太一樣，應該都是在大 object 直接賦值就可以了
        cartsArrayItem.type = channel_name;
        if (channel_name === "delivery") {
          data.data.remoteLocationFee = remoteLocationFee;
        }

        if(channel_name === 'zoneRule') {
          cartsArrayItem.groupName = group_name;
          data.data.zoneCarts.push(cartsArrayItem)
        }else{
          data.data.carts.push(cartsArrayItem);
        }
      });


      let tempNewCarts = [];

      // 將多台購物車壓成一台，存成一個陣列
      // 各商品coupon也只有存成一個對應的陣列(cartProductCoupon) reducers/cart.js
      // 要調回多台的話各商品coupon的陣列也要調整
      data.data.carts.forEach((cart) => {
        if (cart.orders && cart.orders.length) {
          cart.orders.forEach((item) => {
            tempNewCarts.push(item)
          })
        }
      })

      data.data.carts = tempNewCarts;


      data.data.config.isShowCartItem = isShowCartItem;
      // console.log(cartsArray);
      // 下面 return data 打開就是要重新渲染畫面因為 key 應該都會對不到哦
      return data.data;
      // console.log(data);
    }
  }
  // console.log(resCartApiData);

  return resCartApiData;
};

// export const finalCartJsonData = cartJsonData(resCartApiData);
// console.log(finalIndexData);

// 轉換coupon格式
/**
 * @param {*} coupon {
        "amount": 100,
        "absolute": true,
        "id": "0018675G"
    }
 * @returns coupon { "amount": 100, "absolute": true,"id": "0018675G", "showPercent": false}
 */
function couponFormatter(coupon) {
  if (coupon && typeof (coupon.amount) == 'number') {
    return {
      ...coupon,
      showPercent: !coupon.absolute
    }
  }
  return coupon;
}

// 判斷顯示折價區塊
/**
 * @param {*} coupon {
        "amount": 100,
        "absolute": true,
        "id": "0018675G"
    }
 * @param {*} pointToCoupon boolean JSP變數
 * @param {*} cartPoint number JSP變數
 * @param {*} discountDisable boolean
 * @returns boolean
 */
function setDiscountStatus(coupon, pointToCoupon, cartPoint, discountDisable) {
  let returnType = "";

  if (!discountDisable) {
    if (coupon && typeof(coupon.amount) === "number") {
      returnType = "COUPON";
    }
    if (!pointToCoupon && cartPoint > 0) {
      returnType = "USER_POINT";
    }
  }

  return returnType;

}

export const miniCartJson = (miniCartData) => {
  // console.log(miniCartData);
  const {
    Count,
    deliveryPickupCart,
    groupBuyCart,
    miniCartTypeINSTOCK,
    minicartCheckoutUrl,
    preOrderCart,
    vendorCart
  } = miniCartData;

  let allCartType = [];

  // 開始組
  // groupBuyCart
  let groupBuyArray = [];
  groupBuyCart.map((groupBuyItem) => {
    const {
      GDCPRC,     // basePrice
      GDEN,       // entryNumber
      GDID,
      GDMainImg,
      GDNM,
      GDPPRC,
      GDPRC,
      GDQty,
      GDURL
    } = groupBuyItem;

    let returnGroupBuyItem = {
      name: GDNM,
      image: GDMainImg,
      price: {
        listPrice: GDCPRC,
        webPrice: GDPRC,
        discountPrice: GDPPRC
      },
      entry: GDEN,
      sku: GDID,
      qty: GDQty,
      url: GDURL
    };

    groupBuyArray.push(returnGroupBuyItem);
  })

  if (groupBuyArray.length) {
    allCartType.push('GROUPBUY')
  }

  // deliveryPickUpArray
  let deliveryPickUpArray = [];
  deliveryPickupCart.map((deliveryPickUpItem) => {
    const {
      GDCPRC,     // basePrice
      GDEN,       // entryNumber
      GDID,
      GDMainImg,
      GDNM,
      GDPPRC,
      GDPRC,
      GDQty,
      GDURL
    } = deliveryPickUpItem;

    let returnDeliveryPickUpItem = {
      name: GDNM,
      image: GDMainImg,
      price: {
        listPrice: GDCPRC,
        webPrice: GDPRC,
        discountPrice: GDPPRC
      },
      entry: GDEN,
      sku: GDID,
      qty: GDQty,
      url: GDURL
    };
    deliveryPickUpArray.push(returnDeliveryPickUpItem);
  })

  if (deliveryPickUpArray.length) {
    allCartType.push('INSTOCK')
  }

  // preOrderCartArray
  let preOrderArray = [];
  preOrderCart.map((preOrderItem) => {
    const {
      GDCPRC,     // basePrice
      GDEN,       // entryNumber
      GDID,
      GDMainImg,
      GDNM,
      GDPPRC,
      GDPRC,
      GDQty,
      GDURL
    } = preOrderItem;

    let returnPreOrderItem = {
      name: GDNM,
      image: GDMainImg,
      price: {
        listPrice: GDCPRC,
        webPrice: GDPRC,
        discountPrice: GDPPRC
      },
      entry: GDEN,
      sku: GDID,
      qty: GDQty,
      url: GDURL
    };
    preOrderArray.push(returnPreOrderItem);
  })

  if (preOrderArray.length) {
    allCartType.push('PREORDER')
  }

  // preOrderCartArray
  let vendorArray = [];
  vendorCart.map((vendorItem) => {
    const {
      GDCPRC,     // basePrice
      GDEN,       // entryNumber
      GDID,
      GDMainImg,
      GDNM,
      GDPPRC,
      GDPRC,
      GDQty,
      GDURL
    } = vendorItem;

    let returnVendorItem = {
      name: GDNM,
      image: GDMainImg,
      price: {
        listPrice: GDCPRC,
        webPrice: GDPRC,
        discountPrice: GDPPRC
      },
      entry: GDEN,
      sku: GDID,
      qty: GDQty,
      url: GDURL
    };
    vendorArray.push(returnVendorItem);
  })

  if (vendorArray.length) {
    allCartType.push('VENDOR')
  }

  const carts = {
    groupBuyCart: groupBuyArray,
    deliveryPickUpCart: deliveryPickUpArray,
    preOrderCart: preOrderArray,
    vendorCart: vendorArray,
  };

  const nowType = checkMiniCartType(minicartCheckoutUrl);

  let returnJson = {
    count: Count,
    carts: carts,
    config: {
      url: minicartCheckoutUrl,
      isInStock: miniCartTypeINSTOCK,
      nowType: nowType,
      allCartType: allCartType,
    },
    selectedCart: getSelectedCart(nowType, carts)
  }

  console.log(returnJson);



  return returnJson;
}

// 去調整資料結構，如果有priceItem.detail跟priceItem.promotion最後一層，改變裡面的資料結構(現在還沒用到)
function priceGroupFormatter(priceGroup) {
  priceGroup.forEach((priceItem) => {
    priceItem.name = priceItem.dsr;

    if (priceItem.priceDetail && priceItem.priceDetail.length) {
      priceGroupFormatter(priceItem.priceDetail);
    } else {
      if (priceItem.detail && priceItem.detail.length) {
        if (priceItem.promotion && priceItem.promotion.length) {
          priceItem.detail.forEach((item, index) => {
            if (priceItem.promotion[index]) {
              item.name = item.dsr;
              item.link = priceItem.promotion[index].link;
            }
          })
        }
      }
    }
  });

  return priceGroup;
}

function setCartFooterWording(nowCartType) {
  if (nowCartType) {
    const cartType = nowCartType.toLowerCase();

    switch (cartType) {
      case 'instock': {
        return '特力屋宅配商品滿799元免基本運費\n';
      }
      case 'preorder': {
        return '部分商品有額外配送費用，將於訂單受理後由廠商專人報價並由司機代收';
      }
      case "vendor": {
        return "部分商品有額外配送費用，將於訂單受理後由廠商專人報價並由司機代收";
      }
      default:
        return "";
    }
  }
  return "";
}

function checkMiniCartType(nowUrl) {
  if (nowUrl) {
    if (nowUrl.split("type=").length) {
      const nowType = nowUrl.split("type=")[1];
      const nowTypeUppercase = nowType.toUpperCase();
      return nowTypeUppercase;
    }
  }
  return "";
}

export function getSelectedCart(nowType, carts) {
  switch (nowType) {
    case "GROUPBUY": {
      return carts.groupBuyCart
    }
    case "INSTOCK": {
      return carts.deliveryPickUpCart
    }
    case "PREORDER": {
      return carts.preOrderCart
    }
    case "VENDOR": {
      return carts.vendorCart
    }
    default:
      return []
  }
}

export function dealToIsShowExceedFeeAmountWording(volumeExceedFeeAmount, weightExceedFeeAmount) {
  let isShow = false;

  if (
    (volumeExceedFeeAmount != '' && volumeExceedFeeAmount != '$0' && volumeExceedFeeAmount != '0') ||
    (weightExceedFeeAmount != '' && weightExceedFeeAmount != '$0' && weightExceedFeeAmount != '0')
  ) {
    isShow = true;
  }

  return isShow;
}

export function dealToIsShowInstallationWording(installationFeeAmount) {
  let isShow = false;

  if (installationFeeAmount != "" && installationFeeAmount != "$0" && installationFeeAmount != "0") {
    isShow = true;
  }

  return isShow;
}

export function dealToIsShowAscendingFeeAmountWording(ascendingFeeAmount) {
  let isShow = false;

  if( ascendingFeeAmount != '' && ascendingFeeAmount != '$0' && ascendingFeeAmount != '0' ) {
    isShow = true;
  };
  
  return isShow;
}

// 為了顯示第二步 footer 的物流費
function setCarrierFee(priceGroup) {
  const carrierFee = priceGroup.filter((item) => item.dsr === "物流費");

  if( carrierFee.length ) {
    return carrierFee[0].price;
  };
}